import { Component, OnInit, ElementRef, ViewChild, AfterViewChecked , ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from "@angular/router";
import { eventEmitterService } from "../../service/eventEmitter.service";
import { MessageHeaderService } from "../../service/messageheader.service";
declare var $:any;
@Component({
  selector: 'app-messages-header',
  templateUrl: './messages-header.component.html',
  styleUrls: ['./messages-header.component.css'],
  providers : [MessageHeaderService]
})
export class MessagesHeaderComponent implements OnInit {
  page;
  defaultBuilding;
  buildings = [];
  clickedBuildings = [];
  isBuildingManager = false;
  totalMsg = 0;
  totalGroupMsg = 0;
  totalAllGroups = 0;
  buildingArray=[];
  buildingNames=[];
  names='';
  currentUrl;
  constructor(private router: Router,
  private eventService : eventEmitterService,
  private _msgHeaderService : MessageHeaderService,
  private route : ActivatedRoute
  ) {
    router.events.subscribe((data:any) => { this.page = data.url } );
   }

  ngOnInit() {
     this.currentUrl = this.router.url;
     this._msgHeaderService.getUserBuildingsInfo().subscribe((res)=>{
      if(res){
        if(res.buildingsInfo){
            this.buildings = res.buildingsInfo;
        }
      }
    });

    this.route.url.subscribe((url)=>{
      this.page = url[0].path;
    })
     /*this.eventService.eventEmit$
        .subscribe(event => {
          console.log(event)
            if(event.totalMsg != ''){
              this.totalMsg = event.totalMsg;
            }

            if(event.totalGroupMsg != ''){
              this.totalGroupMsg = event.totalGroupMsg;
            }
        });*/

        var totalMsg = 0;
        var totalGroupMsg = 0;
        var totalAllGroups = 0;

        this.eventService._msgCount$
    .subscribe(event => {

            if(event['getAllMsgCount'] != ''){
              totalMsg = event['getAllMsgCount'];
            }else if(event['getAllMsgCount'] == 0){
              totalMsg = 0;
            }
            if(event['getAllGroupMsgCount'] != ''){
              totalGroupMsg = event['getAllGroupMsgCount'];
            }else if(event['getAllGroupMsgCount'] == 0){
              totalGroupMsg = 0;
            }
            if(event['getAllGroupsCount'] != ''){
              totalAllGroups = event['getAllGroupsCount'];
            }else if(event['getAllGroupsCount'] == 0){
              totalAllGroups = 0;
            }
            this.totalMsg = totalMsg;
            this.totalGroupMsg = totalGroupMsg;
            this.totalAllGroups = totalAllGroups;
        });
  }

  clickedItem(buildingId){

    $('#all_building_drp').find('input[type="checkbox"]').each(function(){
       $(this).attr('disabled',true);
    });

    if(this.clickedBuildings.indexOf(buildingId) > -1){
        this.clickedBuildings = this.clickedBuildings.filter(value => value !== buildingId);
    }else{
       this.clickedBuildings.push(buildingId);
    }

    var clickedItemVal = this.clickedBuildings;
    var defaultBuildingVar = '';
    this.buildings.forEach(function callback(building, index, array) {

        var valExists = clickedItemVal.indexOf(building.id);
        if(valExists > -1){
          if(valExists == 0){
             defaultBuildingVar = building;
          }
          building.checked = true;
        }else{
          building.checked = false;
        }
    });
    this.defaultBuilding = defaultBuildingVar;
    this._msgHeaderService.filterByBuildings(this.page, this.clickedBuildings);
    this.eventService.filterBuilding({ filterBuilding : this.clickedBuildings });
    // .subscribe((res)=>{
    //   if(res){
    //     if(res.buildingsInfo){
    //         this.buildings = res.buildingsInfo;
    //     }
    //   }
    // });
    setTimeout(()=> {
      $('#all_building_drp').find('input[type="checkbox"]').each(function(){
        $(this).removeAttr('disabled');
      });
    },2000);

  }

  showAllBuildings(){
    $('#all_building_drp').toggle();
  }

  newMsg(){
    this.eventService.newMessage({ newMsg: true, actionPage : this.page });
    $('.msgList').removeClass('current');
    setTimeout(() => {
      $('.msgContent').addClass('current');
    }, 500);
    $('#messages_header').addClass('current');
  }

  resetGroupImage(){
    sessionStorage.removeItem('groupImage');
    this.eventService.openPopup({openGroupPopup : true});
    $('#add_group_modal').modal('show');
  }

  buildingCheckNames(event, building) {
    console.log(building);
    this.names = '';
    if (event == true) {
      this.buildingArray.push(building.id);
      this.buildingNames.push((building.buildingName) ? building.buildingName : building.formattedAddress.split(',')[0]);
      //this.events.get('eventGroups').patchValue(this.buildingArray);
    } else if (event == false) {    
      const index = this.buildingArray.indexOf(building.id);
      if (index !== -1) {
        this.buildingArray.splice(index, 1);
        this.buildingNames.splice(index, 1)
      }
    }
    this.names = this.buildingNames.toString();
  }

  updateCount(type){

      this.eventService.triggerSocketService(type)
  }
}
